<!--工作室资讯-->
<template>
    <div class="content-container">
        <div class="studio-query-container">
            <div class="studio-topimg-container">
                <img src="../../assets/ms_title.png" alt>
            </div>
        </div>
        <div class="page-info-container" v-show="showMode==='page'">
            <div class="studio-info-nav">
                <div @click="changeNavItem('zx')" :class="navActiveItem==='zx'?'nav-item is-active':'nav-item'">资讯</div>
<!--                <div @click="changeNavItem('gg')" :class="navActiveItem==='gg'?'nav-item is-active':'nav-item'">公告</div>-->
<!--                <div @click="changeNavItem('zc')" :class="navActiveItem==='zc'?'nav-item is-active':'nav-item'">政策</div>-->
            </div>
            <div class="achieve-list-container">
                <div class="achieve-container" v-if="dataList&&dataList.length>0">
<!--                    <div class="achieve-item" v-for="item in dataList" :key="item">-->
<!--                        <div class="achieve-cover">-->
<!--                            <img :src="item.cover" alt />-->
<!--                        </div>-->
<!--                        <div class="achieve-title">{{item.title}}</div>-->
<!--                        <div class="achieve-studio">{{item.groupName}}</div>-->
<!--                    </div>-->
                    <div class="achieve-item-row" v-for="item in dataList" :key="item">
                        <div class="achieve-item-row-title" @click="viewNews(item)">{{item.title}}</div>
                        <div class="achieve-item-row-time">{{timestampToTime(item.releaseTime)}}</div>
                    </div>
                </div>
                <data-empty v-if="dataList&&dataList.length===0" title="暂无资讯"/>
            </div>
            <div class="page-container" v-if="dataList&&dataList.length>0">
                <pageTag :background="true"
                         :pageSizes="[10, 20, 30]"
                         v-show="total > 0"
                         :total="total"
                         v-model:page.sync="queryParams.pageNum"
                         v-model:limit.sync="queryParams.pageSize"
                         @pagination="pageStudioNews" />
            </div>
        </div>

        <!--详情-->
        <div class="page-achieve-container" v-show="showMode==='detail'">
            <news-info :info-id="this.infoId" info-title="资讯详情"/>
        </div>
    </div>
</template>

<script>
import {pageNews} from "@/api/admin/news";
import dataEmpty from "@/components/dataEmpty.vue";
import pageTag from "@/components/Pagination/page.vue";
import {timestampToTime} from "@/utils/date";
import newsInfo from "@/components/studio/newsInfo.vue";

export default {
    name:'studioInfo',
    components:{newsInfo, pageTag, dataEmpty},
    props:{
        studioNature:{
            type: String,
            default:"2"
        },
        newsMode:{
            type: String,
            default:"page"
        }
    },
    watch:{
        newsMode(newValue,oldValue){
            this.showMode = newValue;
        },
    },
    mounted() {
        this.pageStudioNews();
    },
    data() {
        return {
            timestampToTime,
            navActiveItem:'zx',
            pageMode:"page",
            detailMode:"detail",
            showMode:'page',
            queryParams: {
                pageNum: 1,
                pageSize: 10,
                newsType:'',
                status:1,
            },
            total: 0,
            pageCount:0,
            dataList: [],
            infoId:'',
        }
    },
    methods: {
        changeNavItem(activeItem){
            this.navActiveItem=activeItem;
        },
        pageStudioNews(){
            this.queryParams.newsType = this.studioNature;
            pageNews(this.queryParams).then(res=>{
                if (res.data.code === 1) {
                    this.dataList = res.data.data.list;
                    this.total = res.data.data.total;
                    this.pageCount = res.data.data.totalPage;
                }else {
                    this.$message.error("请求出错")
                }
            })
        },
        viewNews(item){
            this.showMode = this.detailMode;
            this.infoId = item.newsId;
            this.$emit('change-mode',this.showMode, '4');
        }
    }
}

</script>

<style scoped>
.content-container{
    width: 100%;
    height: 100%;
    box-sizing: border-box;
}
.studio-query-container{
    width: 100%;
    height: auto;
    background-color: #fff;
}
.studio-topimg-container{
    width: 100%;
    height: 160px;
    img{
        width: 100%;
        height: 100%;
    }
}
.page-info-container{
    width: 100%;
    height: auto;
    padding-bottom: 10px;
    background-color: #fff;
}
.studio-info-nav{
    width: 98%;
    height: 36px;
    display: flex;
    margin: auto;
    border-bottom: 2px solid #3b62f8;
}
.nav-item{
    width: 60px;
    height: 36px;
    line-height: 36px;
    font-size: 16px;
    cursor: pointer;
    color: #333333;
    font-weight: bold;

}
.is-active{
    font-weight: 600;
    color: #3b62f8;
}

.achieve-list-container{
    width: 100%;
    height: auto;
    margin: auto;
    overflow-x: hidden;
}
.achieve-container{
    width: 98%;
    margin: auto;
    display: flex;
    flex-wrap: wrap;
}
.achieve-item{
    width: 25%!important;
    height: 230px;
    padding: 10px 10px 10px 10px;
    box-sizing: border-box;
    border-radius: 10px;
    cursor: pointer;
}
.achieve-cover{
    width: 100%;
    height: 160px;
    img{
        width: 100%;
        height: 100%;
    }
}
.achieve-title{
    width: 100%;
    height: 30px;
    line-height: 30px;
    color: #333333;
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.achieve-studio{
    width: 100%;
    height: 20px;
    line-height: 20px;
    color: #3b62f8;
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.page-container{
    display: grid;
    place-items: center;
    width: 98%;
    height: 40px;
    margin-bottom: 10px;
    margin-top: 10px;
}

.achieve-item-row{
    width: 100%;
    height: 30px;
    display: flex;
}
.achieve-item-row-title{
    width: calc(100% - 200px);
    height: 30px;
    line-height: 30px;
    font-size: 15px;
    color: #3b62f8;
    cursor: pointer;
}

.achieve-item-row-time{
    width: 200px;
    height: 30px;
    line-height: 30px;
    text-align: right;
    font-size: 15px;
    color: #cecece !important;
    padding-right: 10px;
    box-sizing: border-box;
}

</style>